import { FormStatus } from '@/common/'

const mocStatusMixins = {

  methods: {
    isClosed(status) {
      switch (status.value) {
        case FormStatus.CLOSED:
        case FormStatus.CLOSEDREJECTED:
        case FormStatus.CLOSEDVOIDED:
        case FormStatus.CLOSEDSTRANDED:
          return true
        default:
          return false
      }
    }
  }
}


export default mocStatusMixins;